/**
 * The app's version, and what a newer one means for the engine (Phase 5b,
 * step 2: moved out of the update manager, which is the interface's,
 * interfaces/classic/ui/update-manager.js).
 *
 *   getVersion()              this build's version, sent with every change
 *   announceUpdate(update)    the server says a newer version exists
 *                             ({ version, level, message }): the interface
 *                             decides what the person sees (Events.UPDATE_AVAILABLE)
 *   stopSyncForUpdate()       a newer version is required: this build sends
 *                             nothing more until the page reloads
 *   isSyncStoppedForUpdate()
 */
import { APP_VERSION } from "./version.js";
import { emit, Events } from "../core/events.js";

let syncStopped = false;

export function getVersion() {
  return APP_VERSION;
}

export function announceUpdate(update) {
  emit(Events.UPDATE_AVAILABLE, update);
}

export function stopSyncForUpdate() {
  syncStopped = true;
}

export function isSyncStoppedForUpdate() {
  return syncStopped;
}
